/* eslint-disable no-class-assign */
import React from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import Api from '../Api';

const FORM_NAME = 'kioskDeploymentSetForm';
const DEFAULT_CHOOSE_KIOSK_DEPLOYMENT_SET = '-Choose Kiosk Deployment Set-';

class KioskDeploymentSetForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      printapiSelectList: _toSelectList('printapi'),
      payapiSelectList: _toSelectList('payapi'),
      capuiSelectList: _toSelectList('capui'),
      kskapiSelectList: _toSelectList('kskapi'),
      cafeapiSelectList: _toSelectList('cafeapi'),
      linuxdashSelectList: _toSelectList('linuxdash'),
      heatwaveSelectList: _toSelectList('heatwave'),
      kioskprobeSelectList: _toSelectList('kioskprobe'),
      ciscoampSelectList: _toSelectList('ciscoamp'),
      inProgress: false,
      selectedSourceDeploymentSetName: DEFAULT_CHOOSE_KIOSK_DEPLOYMENT_SET,
    };
    this.renderInput = this.renderInput.bind(this);
    this.renderSelect = this.renderSelect.bind(this);
    this.renderCheckbox = this.renderCheckbox.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.handleCopyListSelect = this.handleCopyListSelect.bind(this);
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  componentDidMount() {
    // console.log('KioskDeploymentSetForm.componentDidMount');
    Api.getBuildVersionsFromArtifactory('printapi').then((versions) => {
      if (this.unmounted) return;
      this.setState({ printapiSelectList: _toSelectList('printapi', versions) });
    });
    Api.getBuildVersionsFromArtifactory('payapi').then((versions) => {
      if (this.unmounted) return;
      this.setState({ payapiSelectList: _toSelectList('payapi', versions) });
    });
    Api.getBuildVersionsFromArtifactory('capui').then((versions) => {
      if (this.unmounted) return;
      this.setState({ capuiSelectList: _toSelectList('capui', versions) });
    });
    Api.getBuildVersionsFromArtifactory('kskapi').then((versions) => {
      if (this.unmounted) return;
      this.setState({ kskapiSelectList: _toSelectList('kskapi', versions) });
    });
    Api.getBuildVersionsFromArtifactory('cafeapi').then((versions) => {
      if (this.unmounted) return;
      this.setState({ cafeapiSelectList: _toSelectList('cafeapi', versions) });
    });
    Api.getBuildVersionsFromArtifactory('linuxdash').then((versions) => {
      if (this.unmounted) return;
      this.setState({ linuxdashSelectList: _toSelectList('linuxdash', versions) });
    });
    Api.getBuildVersionsFromArtifactory('heatwave').then((versions) => {
      if (this.unmounted) return;
      this.setState({ heatwaveSelectList: _toSelectList('heatwave', versions) });
    });
    Api.getBuildVersionsFromArtifactory('kiosk-probe').then((versions) => {
      if (this.unmounted) return;
      this.setState({ kioskprobeSelectList: _toSelectList('kioskprobe', versions) });
    });
    Api.getBuildVersionsFromArtifactory('cisco-amp').then((versions) => {
      if (this.unmounted) return;
      this.setState({ ciscoampSelectList: _toSelectList('ciscoamp', versions) });
    });
  }

  handleCopyListSelect(event) {
    let value = event.target.value;
    this.setState({ selectedSourceDeploymentSetName: value });
    if (value !== DEFAULT_CHOOSE_KIOSK_DEPLOYMENT_SET) {
      let filterList = this.props.kvsList.filter((kvs) => kvs.name === value);
      if (filterList.length > 0) {
        let selectedKvs = filterList[0];
        const { change } = this.props;
        change('printapi', selectedKvs.printapi);
        change('payapi', selectedKvs.payapi);
        change('capui', selectedKvs.capui);
        change('kskapi', selectedKvs.kskapi);
        change('cafeapi', selectedKvs.cafeapi);
        change('heatwave', selectedKvs.heatwave);
        change('linuxdash', selectedKvs.linuxdash);
        change('kioskprobe', selectedKvs.kioskprobe);
        change('ciscoamp', selectedKvs.ciscoamp);
      }
    }
  }

  static validate(values) {
    const errors = {};
    if (!values.name) {
      errors.name = 'Required';
    }

    if (!values.printapi) {
      errors.printapi = 'Required';
    }

    if (!values.payapi) {
      errors.payapi = 'Required';
    }

    if (!values.capui) {
      errors.capui = 'Required';
    }

    if (!values.kioskprobe) {
      errors.kioskprobe = 'Required';
    }

    if (!values.kskapi) {
      errors.kskapi = 'Required';
    }

    if (!values.reason) {
      errors.reason = 'Required';
    }

    return errors;
  }

  static warn(values) {
    const warnings = {};
    // if (values && values.email && values.email.indexOf('@readytouch.com') == -1) {
    //   warnings.email = 'Hmm, you are not using readytouch.com...'
    // }
    return warnings;
  }

  renderInput({ input, label, type, disabled, autoFocus, meta: { touched, error, warning } }) {
    return (
      <div className='pure-control-group'>
        <label>{label}</label>
        <input
          className='pure-input-2-3'
          {...input}
          placeholder={label}
          type={type}
          disabled={disabled}
          autoFocus={autoFocus}
          style={{ backgroundColor: disabled ? '#fefefe' : 'inherit' }}
        />
        {touched &&
          ((error && <span style={{ paddingLeft: '10px', color: 'red' }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    );
  }

  renderSelect({ input, label, children, meta: { touched, error, warning } }) {
    return (
      <div className='pure-control-group'>
        <label>{label}</label>
        <select className='pure-input-2-3' {...input} placeholder={label}>
          {children}
        </select>
        {touched &&
          ((error && <span style={{ paddingLeft: '10px', color: 'red' }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    );
  }

  renderCheckbox({ input, label, type, meta: { touched, error, warning } }) {
    return (
      <div className='pure-controls'>
        <label className='pure-checkbox'>
          <input {...input} type='checkbox' /> {label}
        </label>
        {touched &&
          ((error && <span style={{ paddingLeft: '10px', color: 'red' }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    );
  }

  handleDeleteClick(e) {
    e.preventDefault(); // prevent  form submit
    if (this.props.invalid) {
      // validation failed
      return;
    }
    let name = this.props.initialValues.name;
    let thisForm = this.props.stateForm[FORM_NAME] || {}; // stateForm is redux store's state.form
    let values = thisForm.values || {};
    let reason = values.reason;
    this.setState({ inProgress: true }, () => {
      this.props.onDelete(name, reason).finally(() => {
        this.setState({ inProgress: false });
      });
    });
  }

  handleCancelClick(e) {
    e.preventDefault(); // prevent form submit
    this.props.onCancel();
  }

  render() {
    const { handleSubmit, submitting, initialValues, kvsList, lastUpdateReason } = this.props;
    const printapiSelectList = this.state.printapiSelectList || [];
    const payapiSelectList = this.state.payapiSelectList || [];
    const capuiSelectList = this.state.capuiSelectList || [];
    const kskapiSelectList = this.state.kskapiSelectList || [];
    const cafeapiSelectList = this.state.cafeapiSelectList || [];
    const linuxdashSelectList = this.state.linuxdashSelectList || [];
    const heatwaveSelectList = this.state.heatwaveSelectList || [];
    const kioskprobeSelectList = this.state.kioskprobeSelectList || [];
    const ciscoampSelectList = this.state.ciscoampSelectList || [];
    let isCreate = initialValues.isCreate;
    let updatedBy = initialValues.updatedBy;

    let inProgress = submitting || this.state.inProgress;

    let kvsSelectList = [{ name: DEFAULT_CHOOSE_KIOSK_DEPLOYMENT_SET }, ...kvsList];

    return (
      <div
        className='kvs-form pure-form pure-form-aligned'
        style={{ padding: '20px 0', width: '950px', fontSize: 18 }}
        onSubmit={handleSubmit}
      >
        <form>
          <input type='hidden' name='updatedBy' defaultValue={updatedBy} />
          <Field
            name='name'
            component={this.renderInput}
            type='text'
            label='Name'
            disabled={!isCreate}
            autoFocus={isCreate}
          />
          <Field name='printapi' component={this.renderSelect} label='printapi'>
            {printapiSelectList.map((item) => (
              <option key={item.key} value={item.key}>
                {item.value}
              </option>
            ))}
          </Field>
          <Field name='payapi' component={this.renderSelect} label='payapi'>
            {payapiSelectList.map((item) => (
              <option key={item.key} value={item.key}>
                {item.value}
              </option>
            ))}
          </Field>
          <Field name='capui' component={this.renderSelect} label='capui'>
            {capuiSelectList.map((item) => (
              <option key={item.key} value={item.key}>
                {item.value}
              </option>
            ))}
          </Field>
          <Field name='kioskprobe' component={this.renderSelect} label='kiosk-probe'>
            {kioskprobeSelectList.map((item) => (
              <option key={item.key} value={item.key}>
                {item.value}
              </option>
            ))}
          </Field>
          <Field name='kskapi' component={this.renderSelect} label='kskapi'>
            {kskapiSelectList.map((item) => (
              <option key={item.key} value={item.key}>
                {item.value}
              </option>
            ))}
          </Field>
          <Field name='cafeapi' component={this.renderSelect} label='cafeapi'>
            {cafeapiSelectList.map((item) => (
              <option key={item.key} value={item.key}>
                {item.value}
              </option>
            ))}
          </Field>
          <Field name='heatwave' component={this.renderSelect} label='heatwave'>
            {heatwaveSelectList.map((item) => (
              <option key={item.key} value={item.key}>
                {item.value}
              </option>
            ))}
          </Field>
          <Field name='linuxdash' component={this.renderSelect} label='linuxdash'>
            {linuxdashSelectList.map((item) => (
              <option key={item.key} value={item.key}>
                {item.value}
              </option>
            ))}
          </Field>
          <Field name='ciscoamp' component={this.renderSelect} label='cisco-amp'>
            {ciscoampSelectList.map((item) => (
              <option key={item.key} value={item.key}>
                {item.value}
              </option>
            ))}
          </Field>
          <Field
            name='reason'
            component={this.renderInput}
            type='text'
            label={isCreate ? 'Create Reason' : 'Update Reason'}
            autoFocus={!isCreate}
          />
          {!isCreate && (
            <div className='pure-control-group'>
              <label>Last {isCreate ? 'Create Reason' : 'Update Reason'}</label>
              <div className='pure-input-2-3' style={{ display: 'inline-block' }}>
                {lastUpdateReason}
              </div>
            </div>
          )}
          {!isCreate && (
            <div className='pure-control-group'>
              <label>Last Updated</label>
              <div className='pure-input-2-3' style={{ display: 'inline-block' }}>
                {initialValues.lastUpdatedDateTime} ({initialValues.lastUpdatedXAgo})
              </div>
            </div>
          )}
          <div className='pure-control-group'>
            <label>{isCreate ? 'Created' : 'Updated'} By</label>
            <div className='pure-input-2-3' style={{ display: 'inline-block' }}>
              {initialValues.updatedBy}
            </div>
          </div>
          <div className='pure-controls'>
            <button
              style={{ margin: '0 10px' }}
              className='pure-button'
              disabled={inProgress}
              onClick={this.handleCancelClick}
            >
              Cancel
            </button>
            <button
              style={{ margin: '0 10px' }}
              className='pure-button pure-button-primary'
              type='submit'
              disabled={inProgress}
            >
              {isCreate ? 'Create' : 'Update'}
            </button>
            {!isCreate && (
              <button
                style={{ margin: '0 10px' }}
                className='pure-button pure-button-danger'
                disabled={inProgress}
                onClick={this.handleDeleteClick}
              >
                Delete
              </button>
            )}
            {/*
            <button className="pure-button pure-button-primary" disabled={pristine || submitting} onClick={reset}>
              Reset Changes
            </button>
          */}
          </div>
        </form>

        <div className='pure-control-group' style={{ margin: '40px 0' }}>
          <label>Copy From</label>
          <select
            className='pure-input-2-3'
            placeholder='-Choose Kiosk Deployment Set-'
            onChange={this.handleCopyListSelect}
          >
            {kvsSelectList.map((kvs) => {
              return (
                <option key={kvs.name} value={kvs.name}>
                  {kvs.name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    );
  }
}

function _toSelectList(project, versions = []) {
  let kvObjList = [{ key: '', value: '-Choose-' }];
  for (let v of versions) {
    kvObjList.push({ key: v, value: v });
  }
  return kvObjList;
}

// Decorate the form component
KioskDeploymentSetForm = reduxForm({
  form: FORM_NAME, // a unique name for this form
  validate: KioskDeploymentSetForm.validate,
  warn: KioskDeploymentSetForm.warn,
})(KioskDeploymentSetForm);

export default KioskDeploymentSetForm;



// WEBPACK FOOTER //
// ./src/components/KioskDeploymentSetForm.js